// extracted by mini-css-extract-plugin
module.exports = {"Auth":"ResetPassword_Auth__WCI28"};